<ng-container *transloco="let t">
    <div class="flex flex-col flex-auto w-full">
        <div class="flex items-center justify-between w-full ml-3">
            <div><h2 class="text-3xl font-semibold tracking-tight leading-8">{{ t('shops') }}</h2></div>
            <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
                <mat-form-field
                    class="fuse-mat-dense fuse-mat-rounded min-w-64"
                    [subscriptSizing]="'dynamic'">
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_solid:search'"></mat-icon>
                    <input
                        matInput
                        [formControl]="searchInputControl"
                        [autocomplete]="'off'"
                        placeholder="{{t('searchShops')}}">
                </mat-form-field>
            </div>
        </div>
        <div class="flex flex-wrap w-full max-w-screen-xl mx-auto p-3">
            <div class="table-container mat-elevation-z6 mt-2 sm:absolute" style="padding-bottom: 65px; width: 100%;">
                <table mat-table [dataSource]="(shops$ | async) || []" matSort
                       (matSortChange)="onSortChange($event)">

                    <ng-container matColumnDef="shopId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="p.shopId">
                            <b>{{t('id')}}</b></th>
                        <td mat-cell *matCellDef="let shop">{{shop.id}}</td>
                    </ng-container>

                    <ng-container matColumnDef="taxId">
                        <th mat-header-cell *matHeaderCellDef><b>{{t('taxId')}}</b></th>
                        <td mat-cell *matCellDef="let shop">{{shop.taxId}}</td>
                    </ng-container>

                    <ng-container matColumnDef="shopName">
                        <th mat-header-cell *matHeaderCellDef><b>{{t('shopName')}}</b></th>
                        <td mat-cell *matCellDef="let shop">{{shop.shopName}}</td>
                    </ng-container>

                    <ng-container matColumnDef="companyName">
                        <th mat-header-cell *matHeaderCellDef><b>{{t('companyName')}}</b></th>
                        <td mat-cell *matCellDef="let shop">{{shop.companyName}}</td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>


                <mat-paginator
                    class="sm:absolute sm:inset-x-0 sm:bottom-0 border-b sm:border-t sm:border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                    style="position: fixed !important; left: 283px !important; bottom: 0 !important;"
                    [ngClass]="{'pointer-events-none': isLoading}"
                    (page)="onPaginateChange($event)"
                    [pageSizeOptions]="[10, 25, 100]" [length]="pagination?.totalRecords"
                    showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</ng-container>

